module.exports = __webpack_public_path__ + "static/media/BAJAJAUTOLTD2014.667eb8d0.png";